import { DOCUMENT_BLOCK_TYPES, DOCUMENT_ALIGN } from "./schema";

/** Mirrors `templates/recibo_simples.md` for live preview. */
const reciboSimples = {
  id: "recibo-simples",

  blocks: [
    {
      type: DOCUMENT_BLOCK_TYPES.TITLE,
      content: "RECIBO",
      align: DOCUMENT_ALIGN.CENTER,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content:
        "Recebi de {NOME_PESSOA_FISICA}, inscrito(a) no CPF/CNPJ sob o nº {CPF_CNPJ_PAGADOR}, a importância de R$ {VALOR} ({VALOR_EXTENSO}), referente a {REFERENTE}.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 1 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "Forma de pagamento: {FORMA_PAGAMENTO}.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "Para maior clareza e validade, firmo o presente recibo.",
      align: DOCUMENT_ALIGN.JUSTIFY,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{CIDADE}, {DATA}.",
      align: DOCUMENT_ALIGN.RIGHT,
    },

    { type: DOCUMENT_BLOCK_TYPES.SPACER, lines: 2 },

    {
      type: DOCUMENT_BLOCK_TYPES.PARAGRAPH,
      content: "{ASSINATURA_RECEBEDOR}",
    },
  ],
};

export default reciboSimples;
